module.exports = __webpack_public_path__ + "static/media/frank_medium.a7b6d8bc.png";